import { changePassword } from '@biz-models/network/login-authenticate-network.model';
import { createAction } from '@ngrx/store';
import { ActionSourceKey } from 'src/controls/store-keys.enum';
import { ActionUtil } from 'src/util/action.util';

const authEffect = ActionSourceKey.AUTH_TOKEN_EFFECTS;
const apiService = ActionSourceKey.API_SERVICE;
const invalidTokenEfect = ActionSourceKey.INVALID_TOKEN_EFFECTS;

// export const GetAuthTokenFromLocalStorage = createAction(`[${authEffectSource}] Get Auth Token From Local Storage`);
export const InitialiseAuthToken = createAction(`[${authEffect}] Initialise Auth Token`);
export const SetAuthTokenToStore = createAction(`[${authEffect}] Set Auth Token To Store`, (token: string) => ({ payload: { token } }));
export const NoAuthTokenRetrieved = createAction(`[${authEffect}] No Auth Token Retrieved`);
export const ValidateAuthToken = createAction(`[${authEffect}] Validate Auth Token`, (token: string) => ({ payload: { token } }));
export const ValidateAuthTokenSuccess = createAction(`[${authEffect}] Validate Auth Token Success`);
export const ValidateAuthTokenFailed = createAction(`[${authEffect}] Validate Auth Token Success Failed`, ActionUtil.errorPayload);
export const ApiInvalidToken = createAction(`[${apiService}] Invalid Token`, (options: { url?: string } = {}) => ({ payload: { ...options } }));

export const ChangePasswordSuccess = createAction(`[${apiService}] Change Password Success`, (payload: { data: []; message: string; code_status: number }) => payload);

export const ChangePasswordFail = createAction(`[${apiService}] Change Password Fail`, (payload: Error) => payload);

export const SessionExpireDialogClosed = createAction(`[${invalidTokenEfect}] Session Expire Dialog Closed`);
